import axios from 'axios';

const REFRESH_INTERVAL = 30 * 60 * 1000; // 30 minutes in milliseconds
let refreshTimer = null;

export const setupTokenRefresh = () => {
  const token = localStorage.getItem('token');
  if (!token) return;

  // Clear any existing refresh timer
  if (refreshTimer) {
    clearInterval(refreshTimer);
  }

  // Set up periodic token refresh
  refreshTimer = setInterval(async () => {
    try {
      const response = await axios.post('/api/auth/refresh-token', null, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
      
      if (response.data.token) {
        localStorage.setItem('token', response.data.token);
      }
    } catch (error) {
      console.error('Token refresh failed:', error);
      if (error.response?.status === 401) {
        handleTokenExpiration();
      } else if (error.response?.status === 403 && error.response?.data?.blocked) {
        handleBlockedUser();
      }
    }
  }, REFRESH_INTERVAL);
};

export const handleTokenExpiration = () => {
  // Clear the refresh timer
  if (refreshTimer) {
    clearInterval(refreshTimer);
  }

  // Clear local storage
  localStorage.removeItem('token');

  // Redirect to login page
  window.location.href = '/login';
};

export const handleBlockedUser = () => {
  // Clear the refresh timer
  if (refreshTimer) {
    clearInterval(refreshTimer);
  }

  // Clear local storage
  localStorage.removeItem('token');

  // Create and show blocked user popup
  showBlockedUserPopup();
};

const showBlockedUserPopup = () => {
  // Remove any existing popup
  const existingPopup = document.getElementById('blocked-user-popup');
  if (existingPopup) {
    existingPopup.remove();
  }

  // Create popup HTML
  const popupHTML = `
    <div id="blocked-user-popup" class="blocked-popup" style="
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.6);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 10000;
      animation: fadeIn 0.3s ease-in-out;
    ">
      <div class="blocked-popup-content" style="
        background: white;
        padding: 40px 30px;
        border-radius: 15px;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
        text-align: center;
        max-width: 400px;
        width: 90%;
        animation: slideIn 0.3s ease-out;
      ">
        <div class="blocked-icon" style="
          font-size: 60px;
          margin-bottom: 20px;
          display: block;
        ">🚫</div>
        <h3 style="
          color: #dc3545;
          font-size: 24px;
          font-weight: bold;
          margin-bottom: 15px;
          margin-top: 0;
        ">Account Blocked</h3>
        <p style="
          color: #666;
          font-size: 16px;
          line-height: 1.5;
          margin-bottom: 25px;
          margin-top: 0;
        ">Your account has been blocked by admin. Please contact support for assistance.</p>
        <button id="blocked-ok-button" style="
          background: linear-gradient(90deg, #dc3545, #c82333);
          color: white;
          border: none;
          padding: 12px 30px;
          border-radius: 8px;
          font-size: 16px;
          font-weight: bold;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 4px 15px rgba(220, 53, 69, 0.3);
        ">OK</button>
      </div>
    </div>
  `;

  // Add CSS animations if not already present
  if (!document.getElementById('blocked-popup-styles')) {
    const style = document.createElement('style');
    style.id = 'blocked-popup-styles';
    style.textContent = `
      @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }
      @keyframes slideIn {
        from {
          opacity: 0;
          transform: translateY(-50px) scale(0.9);
        }
        to {
          opacity: 1;
          transform: translateY(0) scale(1);
        }
      }
    `;
    document.head.appendChild(style);
  }

  // Add popup to DOM
  document.body.insertAdjacentHTML('beforeend', popupHTML);

  // Add event listener to OK button
  const okButton = document.getElementById('blocked-ok-button');
  if (okButton) {
    okButton.addEventListener('click', () => {
      const popup = document.getElementById('blocked-user-popup');
      if (popup) {
        popup.remove();
      }
      window.location.href = '/login';
    });

    // Add hover effect
    okButton.addEventListener('mouseenter', () => {
      okButton.style.background = 'linear-gradient(90deg, #c82333, #bd2130)';
      okButton.style.boxShadow = '0 6px 20px rgba(220, 53, 69, 0.4)';
      okButton.style.transform = 'translateY(-2px)';
    });

    okButton.addEventListener('mouseleave', () => {
      okButton.style.background = 'linear-gradient(90deg, #dc3545, #c82333)';
      okButton.style.boxShadow = '0 4px 15px rgba(220, 53, 69, 0.3)';
      okButton.style.transform = 'translateY(0)';
    });
  }
};

// Setup axios interceptor to handle 401 and 403 responses
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      handleTokenExpiration();
    } else if (error.response?.status === 403 && error.response?.data?.blocked) {
      handleBlockedUser();
    }
    return Promise.reject(error);
  }
); 